function TagInput(el, options) {
    this.$el = el;
    $(this.$el).attr('class', 'd-none');
    this.$value = [];
    this.$el.value = (this.$el.value) ? this.$el.value : JSON.stringify(this.$value);
    this.$itemListEl = document.createElement('ul');
    this.$contentEl = document.createElement('div');
    this.$contentListEl = document.createElement('ul');
    this.$inputEl = document.createElement('input');
    this.$timeout = null;
    this.$contentClosing = false;
    this.$optionSearch = options.search;
    this.$withNew = options.withNew;
};

TagInput.prototype = {
    constructor: TagInput,
    /**
     * Create Element
     */
    create: function () {
        // Create a div wrapper
        const wrapperEl = document.createElement('div')
        wrapperEl.setAttribute('class', 'position-relative');
        // Div Input
        const divInput = document.createElement('div')
        divInput.setAttribute('class', 'b-form-tags form-control form-control-sm h-auto')
        this.$itemListEl.setAttribute('class', 'b-form-tags-list list-unstyled mb-0 d-flex flex-wrap align-items-center')
        divInput.appendChild(this.$itemListEl);
        const li = document.createElement('li')
        li.setAttribute('class', 'b-form-tags-field flex-grow-1')
        this.$itemListEl.appendChild(li);
        const divLi = document.createElement('div')
        divLi.setAttribute('class', 'd-flex')
        li.appendChild(divLi)
        this.$inputEl.setAttribute('type', 'text')
        this.$inputEl.setAttribute('style', 'outline: 0px; min-width: 5rem;');
        this.$inputEl.setAttribute('placeholder', $(this.$el).attr('placeholder'))
        this.$inputEl.setAttribute('class', 'b-form-tags-input w-100 flex-grow-1 p-0 m-0 bg-transparent border-0')
        divLi.appendChild(this.$inputEl);
        // Div Content
        this.$contentEl = document.createElement('div')
        this.$contentEl.setAttribute('class', 'b-form-tag--content invisible')
        this.$contentEl.appendChild(this.$contentListEl)
        // Appends
        $(wrapperEl).append(divInput);
        $(wrapperEl).append(this.$contentEl);
        $(this.$el).parent().append(wrapperEl);

        if (this.$el.value.length !== 0) {
            try {
                const value = JSON.parse(this.$el.value);
                for (var item of value) {
                    this.add(item, true);
                }
            } catch (e) {}
        }
        // Add events
        this.$inputEl.addEventListener('keyup', (e) => {
            if (e.keyCode === 13 || e.keyCode === 38 || e.keyCode === 40) return;
            this.onKeyUp(e)
        });
        this.$inputEl.addEventListener('keydown', (e) => {
            if (e.keyCode === 13) e.preventDefault();
        });
        $(this.$itemListEl).on('click', 'button', (e) => {
            const target = e.target.parentNode;
            this.remove(target);
        });
        $(this.$el).on('importChange', (e, data) => {
            this.reset();
            for (var item of data.value) {
                if (item.id || this.$withNew) {
                    this.add(item, true);
                }
            }
        });
        document.addEventListener('keydown', (e) => {
            if (e.keyCode === 13) this.onEnterItem(e);
            else if (e.keyCode === 38) this.onUpItem()
            else if (e.keyCode === 40) this.onDownItem();
        });
        document.addEventListener('click', (e) => {
            const target = e.target;
            if (target !== this.$inputEl && !this.$contentEl.contains(target)) {
                $(this.$contentEl).addClass('invisible')
                $(this.$contentEl).removeClass('visible')
            }
            if (this.$inputEl === target && $(this.$inputEl).val().length != 0) {
                $(this.$contentEl).addClass('visible')
                $(this.$contentEl).removeClass('invisible')
            }
        });
        var _this = this;
        $(this.$contentListEl).on('mouseenter', () => {
            const li = this.$contentListEl.querySelector('li.selected')
            if (!li) return;
            $(li).removeClass('selected');
        })
        $(this.$contentListEl).on('click', 'li', function () {
            _this.onClickItem(this);
        })
    },

    add: function (item, manual = false) {
        if (!manual && $(this.$contentEl).hasClass('invisible')) return;
        // Hide content
        $(this.$contentEl).addClass('invisible')
        $(this.$contentEl).removeClass('visible')
        // Add to value
        this.$value.push(item)
        this.$el.value = JSON.stringify(this.$value);
        // Reset
        this.$contentListEl.innerHTML = '';
        this.$inputEl.value = '';
        // Create html badge
        const li = document.createElement('li')
        li.setAttribute('class', 'badge b-form-tag d-inline-flex align-items-baseline mw-100 ' + (item.id ? 'badge-dark' : (item.cid ? 'badge-info' : 'badge-secondary')))
        $(li).data('name', item.name);
        // Create span
        const span = document.createElement('span')
        span.setAttribute('class', 'b-form-tag-content flex-grow-1 text-truncate')
        span.innerText = item.id ? item.name : (item.cid ? item.name : item.name + ' (new)');
        li.appendChild(span);
        // Create x btn
        const btn = document.createElement('button')
        btn.setAttribute('type', 'button')
        btn.setAttribute('class', 'close b-form-tag-remove')
        btn.innerText = 'x';
        li.appendChild(btn);
        // Add to itemList
        this.$itemListEl.insertBefore(li, this.$inputEl.parentNode.parentNode);
    },

    remove: function (target) {
        const itemName = $(target).data('name');
        this.$value = this.$value.filter(item => item.name !== itemName);
        this.$el.value = JSON.stringify(this.$value);
        target.remove();
    },

    reset: function () {
        this.$value = this.$value = [];
        this.$el.value = JSON.stringify(this.$value);
        $(this.$itemListEl).find('li').not(':last').remove();
    },

    onClickItem: function (target) {
        this.add($(target).data('item'))
    },

    onEnterItem: function (event) {
        const selectedLi = this.$contentListEl.querySelector('li.selected');
        if (!selectedLi) return;
        this.add($(selectedLi).data('item'));
    },

    onUpItem: function () {
        const selectedLi = this.$contentListEl.querySelector('li.selected');
        const lastLi = this.$contentListEl.querySelector('li:last-child');
        if (!selectedLi) {
            if (lastLi) {
                lastLi.classList.add('selected');
            }
            return;
        }
        const prevLi = selectedLi.previousSibling || lastLi;
        selectedLi.classList.remove('selected');
        prevLi.classList.add('selected');
    },

    onDownItem: function () {
        const selectedLi = this.$contentListEl.querySelector('li.selected');
        const firstLi = this.$contentListEl.querySelector('li');
        if (!selectedLi) {
            if (firstLi) {
                firstLi.classList.add('selected');
            }
            return;
        }
        const nextLi = selectedLi.nextSibling || firstLi;
        selectedLi.classList.remove('selected');
        nextLi.classList.add('selected');
    },
    /**
     * Add Content
     */
    addContent: function (items, query) {
        // Create index
        var index = 0,
            isSame = false;
        // Clear content list
        this.$contentListEl.innerHTML = '';
        // Loop items
        for (const item of items) {
            // Check if has the extacly query
            if (item.name.toLowerCase() === query.toLowerCase()) isSame = true;
            // Check if already contains
            if (!!this.$value.find(obj => obj.name.toLowerCase() === item.name.toLowerCase())) continue;
            // Create li
            const li = document.createElement('li')
            $(li).data('item', item);
            $(li).text(item.cid ? `${item.name} [pending]` : item.name);
            // Appent to content list
            this.$contentListEl.appendChild(li);
            // Increase index
            index++;
        }
        // Check has same
        if (!isSame && !this.$value.find(obj => obj.name.toLowerCase() === query.toLowerCase()) && this.$withNew) {
            // Create li
            const li = document.createElement('li')
            $(li).data('item', {
                'name': query
            });
            $(li).text(query + ' (new)');
            // Appent to content list
            this.$contentListEl.prepend(li);
        }
        // first Li
        const firstLi = this.$contentListEl.querySelector('li');
        if (firstLi) {
            firstLi.classList.add('selected');
        } else {
            this.$contentListEl.innerHTML = '<div class="text-center m-auto">Nothing results found.. search again..</div>';
        }
    },

    onKeyUp: function (e) {
        // CLear timeout
        clearTimeout(this.$timeout);
        // Check if input has value
        if ($(this.$inputEl).val().length == 0) {
            $(this.$contentEl).addClass('invisible')
            $(this.$contentEl).removeClass('visible')
        } else {
            $(this.$contentEl).addClass('visible')
            $(this.$contentEl).removeClass('invisible')
            if ($(this.$inputEl).val().length == 1) {
                this.$contentListEl.innerHTML = '<div class="text-center m-auto">Please enter 1 or more characters to search</div>';
                return
            }
        }
        // Add loading spinner
        this.$contentListEl.innerHTML = '<div class="text-center m-auto" role="status"><i class="fas fa-spinner fa-spin"></i></div>';
        //Set timeout
        this.$timeout = setTimeout(() => {
            // Get query from input
            const query = $(this.$inputEl).val();
            // Get items
            this.$optionSearch(query).then(items => {
                // Search
                this.addContent(items, query);
            })
        }, 400);
    },
};

$.fn.formTags = function (arg1, arg2, arg3) {
    this.each(function () {
        var tagsinput = new TagInput(this, arg1);
        tagsinput.create();
    });
};

$.fn.formTags.Constructor = TagInput;
